import { type FC } from 'react'

import SvgIcon, { type IconProps } from './SvgIcon'

const PATH =
  'M22.878 48.718a3.151 3.151 0 0 0 0 2.407 3.109 3.109 0 0 0 .779 1.091c.025.027.033.063.059.089l24.056 24.056a3.149 3.149 0 0 0 4.454-4.454L33.389 53.071h40.822a3.15 3.15 0 1 0 0-6.3H33.388l18.679-18.678a3.149 3.149 0 1 0-4.454-4.454L23.56 47.692a3.159 3.159 0 0 0-.682 1.026z'

const IconArrowLeft: FC<IconProps> = props => <SvgIcon {...props} path={PATH} />

export default IconArrowLeft
